import React from "react";
import styles from "./home.module.css";
import Header from "../../components/Header";
import FormSec from "../../components/FormSec";
import Card from "../../components/Card";
import Footer from "../../components/Footer";

function home() {
  return (
    <div className="">
      <Header />
      <div className={styles.heroimg}>
        <div className="">
          <div className=" pt-[59px] md:pt-[91px] ml-[41px] lg:ml-[170px] xl:ml-[215px] pb-[60px] max-w-[425px]">
            <h2 className="font-[700] text-[20px] md:text-[50px] max-w-[168px] md:max-w-full leading-[20px] md:leading-[70px] text-[#ffffff] pb-[16px]">
              {" "}
              You Complained and We Listened
            </h2>
            <p className=" text-[10px] md:text-[20px] font-[500] leading-[14px] md:leading-[34px] text-[#fff] max-w-[160px] md:max-w-[414px] pb-[14px]">
              {" "}
              Redefine Your Online Shopping Experience With Shopaz Hub
              E-Marketplace
            </p>

            <a href="#joinwaitlist">
              {" "}
              <button className=" w-[110px] md:w-[240px] md:h-[52px] h-[40px] text-[10px] md:text-[16px] bg-tahiti text-[#ffffff] leading-[12px]  rounded-[6px] rounded-bl-[0] font-[700]">
                GET EARLY ACCESS
              </button>
            </a>
          </div>
        </div>
      </div>

      <Card />
      <FormSec />
      <Footer />

      {/* <div className="">
        <div className="">
          <div className="max-w-[706px] mx-auto">
            

            <FormSec />
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default home;
